import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { PREVIEW_MODE, PAYMENTS_ENABLED } from "../../data/siteConfig";
import { getCheckoutHref } from "../../utils/checkout";
export function CheckoutAction() {
  const href = getCheckoutHref();
  if (PREVIEW_MODE || !href) {
    return <button type="button" disabled className="mt-8 flex min-h-14 w-full cursor-not-allowed items-center justify-center gap-2.5 rounded-[10px] border border-navy/15 bg-navy/[0.07] px-3 py-3 font-display text-[18px] font-bold uppercase text-navy/75" data-id="element-100" data-mp="1i0djwcelq1qa">
        <LockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-101" data-mp="180v2a2m5ys1e" />
        Checkout not open
      </button>;
  }
  return <>
      <a href={href} aria-describedby="checkout-note" className="btn-primary mt-8 w-full justify-center" data-id="element-102" data-mp="z1rg2prp9wio">
        Get the Kit
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-103" data-mp="2oiit04z2kpzo" />
      </a>
      <p id="checkout-note" className="mt-4 text-sm leading-relaxed text-navy/75" data-id="element-104" data-mp="2tgkdmuc58xd9">
        {PAYMENTS_ENABLED ? "Digital teaching resources only. Review the order details and available payment methods at checkout." : "The checkout is linked, but payment methods are still being configured. A completed purchase is not yet available."}
      </p>
    </>;
}